// Type definitions copied from tempoissues/mock-data/issues.ts
import { User } from "./users";
import { LabelInterface } from "./labels";
import { Json } from "@/utils/supabase.types";
import { ProjectRunMode } from "@/utils/templateProjects";

export interface CanvasPreview {
  id: string;
  createdAt: string;
  assigned_user_id: string | null;
  labels: string[];
  project_id: string;
  env: string;
  current_branch: string | null;
  owner_user_id: string;
  last_updated: string;
  storyboard_count: number;
}

export interface FeaturePRD {
  id?: string;
  canvas_id?: string;
  title?: string | null;
  prd?: string | null;
  status?: string | null;
  priority?: number;
  order?: number;
  due_date?: string;
  estimate?: number;
  canvas_visual_context?: Json | null;
  created_at?: string;
  design_suggestions?: Json | null;
  mermaid_diagram?: string | null;
}

export interface Project {
  id: string;
  name: string | null;
  labels?: LabelInterface[] | null;
  users?: User[] | null;
  runMode?: ProjectRunMode;
  repoPath?: string;
  provider?: string | null;
  assignedPort?: string | null;
  auto_install_off?: boolean | null;
  base_branch?: string | null;
  componentTemplateExtension?: string | null;
  componentTemplateFile?: string | null;
  containerName?: string | null;
  docker_container_name?: string | null;
  customInstallCommand?: string | null;
  customInstallExtraCommand?: string | null;
  customRunCommand?: string | null;
  devServerPort?: string | null;
  devServerSuffix?: string | null;
  startupCommand?: string | null;
  startCommand?: string | null;
  tempobookPort?: string | null;
  templateProjectId?: string | null;
  templateUserId?: string | null;
  local?: boolean | null;
  mainFilePath?: string | null;
  nodeImage?: string | null;
  nodeVersion?: string | null;
  packageManager?: string | null;
  projectSubfolderPath?: string | null;
  repoId?: string | null;
  disableAutoformat?: boolean | null;
  envFilePath?: string | null;
  exampleComponentPath?: string | null;
  framework?: string | null;
  srcFolderPath?: string | null;
  gitlab_project_id?: string | null;
}

export class Issue {
  canvas: CanvasPreview;
  featurePrd?: FeaturePRD;

  constructor(canvas: CanvasPreview, featurePrd?: FeaturePRD) {
    this.canvas = canvas;
    this.featurePrd = featurePrd;
  }
}

export const ESTIMATE_POINTS = [1, 2, 3, 4, 5] as const;

export const ESTIMATE_TO_TSHIRT_SIZE: { [key: number]: string } = {
  1: "XS",
  2: "S",
  3: "M",
  4: "L",
  5: "XL",
};

export const getTShirtSize = (
  estimate: number | null | undefined
): string | undefined => {
  if (estimate === null || estimate === undefined) return undefined;
  return ESTIMATE_TO_TSHIRT_SIZE[estimate];
};
